/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsObject: {
  name: 'object';
  data: string;
} = {
  name: 'object',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h1v4H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2h4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-1v-4h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1h-4V4a2 2 0 0 0-2-2H4Zm10 16h-4v-2a2 2 0 0 0-2-2H7v-4h1a2 2 0 0 0 2-2V7h4v1a2 2 0 0 0 2 2h1v4h-1a2 2 0 0 0-2 2v2Zm2 1v1h4v-4h-4v3Zm-8 0v-3H4v4h4v-1ZM8 4v4H4V4h4Zm10 4h-2V4h4v4h-2Z" fill="currentColor"/></svg>`,
};
